<style>
@import '../../assets/css/deposit.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_user')}}</template>
                        <el-input v-model="ajaxSearch.login" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date')}}</template>
                        <b-form-input type="date" v-model="ajaxSearch.created_at"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_code')}}</template>
                        <el-input v-model="ajaxSearch.code" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_tx_id')}}</template>
                        <el-input v-model="ajaxSearch.tx_id" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_coin')}}</template>
                        <b-form-select v-model="ajaxSearch.coin_id">
                            <option value="">-</option>
                            <option v-for="(list,index) in ajaxToolList.coinList" :key="index" :value='list.name'>{{list.name}}</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column type="expand">
                        <b-button variant="info" size="lg" @click="infoDeposit()">{{$t('deposit_request.table_info')}}</b-button>
                        <b-button variant="primary" size="lg" class="ml-1" @click="getEditDeposit()" v-if="showEdit && permissionList.includes(permission.edit)">{{$t('deposit_request.table_edit')}}</b-button>
                        <b-button variant="info" size="lg" class="ml-1" :href="ajaxUrl" target="_blank" style="font-size: 15px;">{{$t('admin.table_check_tx_id')}}</b-button>
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>
            <b-modal id="infoDeposit" :title="$t('deposit_request.table_check_deposit')" hide-footer size="lg">
                <b-row class="form-label">
                    <b-col cols="6">
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <p>{{ajaxInfo.id}}</p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_user')}}</template>
                            <p>{{ajaxInfo.login}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <p>{{ajaxInfo.created_at}}</p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <p>{{ajaxInfo.code}}</p>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_total_amount')}}</template>
                            <p>{{ajaxInfo.total_amount}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_convert_rate')}}</template>
                            <p>{{ajaxInfo.convert_rate}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_convert_amount')}}</template>
                            <p>{{ajaxInfo.convert_amount}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_tx_id')}}</template>
                            <p style="word-wrap: break-word">{{ajaxInfo.tx_id}}</p>                                                        
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
            <b-modal id="editDeposit" :title="$t('deposit_request.table_check_deposit')" :ok-title="$t('button.submit')" :cancel-title="$t('button.close')" @ok="editDeposit" size="lg">
                <b-row class="form-label">
                    <b-col cols="6">
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <p>{{ajaxEdit.id}}</p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <p>{{ajaxEdit.created_at}}</p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <p>{{ajaxEdit.code}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_total_amount')}}</template>
                            <p>{{ajaxEdit.total_amount}}</p>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <p>{{ajaxEdit.status_name}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="5">
                            <template slot="label">{{$t('admin.table_user')}}</template>
                            <p>{{ajaxEdit.login}}</p>                                                        
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-select name="status" v-model="ajaxEdit.status">
                                <option v-for="(status,index) in statusList" :key="index" :value="status.id">{{status.name}}</option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
    </div>
</template>

<script>
import {depositAjaxTable,depositInfo,getDepositEdit,depositEdit} from '@/system/model/deposit';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{  
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',code:'',master_id:'',coin_id:'',total_amount:'',convert_amount:'',tx_id:'',login:''},
            ajaxRow:'',
            ajaxUrl:'',
            ajaxInfo:[],
            ajaxEdit:[],
            statusList:[],
            showEdit:false,
            pageLimit:10,
            permission:{
                edit:'9CC749'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'111'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'326'
            },{
                prop: "master_id",
                label: this.$t('admin.table_user'),
                width:'217'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width:'217'
            },{
                prop: "coin_id",
                label: this.$t('admin.table_coin'),
                width:'217'
            },{
                prop: "convert_amount",
                label: this.$t('admin.table_deposit_amount'),
                width:'217'
            },{
                prop: "total_amount",
                label: this.$t('admin.table_usdt_amount'),
                width:'217'
            }]
        }
    },methods:{
        initialize(){
            var self = this;
            var result = depositAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.code,this.ajaxSearch.master_id,this.ajaxSearch.coin_id,this.ajaxSearch.total_amount,this.ajaxSearch.convert_amount,this.ajaxSearch.tx_id,this.ajaxSearch.login);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },infoDeposit(){
            var self = this;
            var result = depositInfo(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$bvModal.show('infoDeposit');
                    self.ajaxInfo = value.data;
                }
            });
        },getEditDeposit(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getDepositEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editDeposit');
                        self.ajaxEdit = value.data.thisDetail;
                        self.statusList = value.data.statusList;
                    }
                });
            }
        },editDeposit(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var formData = new FormData();
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('status', this.ajaxEdit.status); 
                formData.append('id', this.ajaxRow); 
                var result = depositEdit(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                            
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
            this.ajaxUrl = row.url;
            this.showEdit = false;
            if(row.status == 1){
                this.showEdit = true;
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
